import loadable from "@loadable/component";
import { useState } from "react";
import Spinner from "../../components/Reusable/Spinner";
import moment from "moment";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";

const KMRecordComponent = loadable(
  () => import("../../components/KMRecord/KMRecord")
);

const KMRecord = () => {
  const [currentMonth, setCurrentMonth] = useState(moment());
  const [selectedRider, setSelectedRider] = useState(null);
  const [refetchDate, setRefetch] = useState(currentMonth.format("YYYY-MM-DD"));
  const currentDateTime = new Date();
  const year = currentDateTime.getFullYear();
  const month = String(currentDateTime.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are zero-based
  const startDay = String(currentDateTime.getDate()).padStart(2, "0");
  const endDay = String(currentDateTime.getDate()).padStart(2, "0");
  const startDate = `${year}-${month}-${startDay}`;
  const endDate = `${year}-${month}-${endDay}`;

  const { data: kmRecordSetting, refetch } = useGetHook({
    queryKey: ["km-record-settings"],
    url: APIS.KM_RECORD_SETTING,
    params: {},
  });

  return (
    <>
      <KMRecordComponent
        kmRecordSetting={kmRecordSetting}
        refetch={refetch}
        setCurrentMonth={setCurrentMonth}
        currentMonth={currentMonth}
        startDate={startDate}
        endDate={endDate}
        setRefetch={setRefetch}
        selectedRider={selectedRider}
        setSelectedRider={setSelectedRider}
      />
    </>
  );
};

export default KMRecord;
